import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Wrench, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Auth() {
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      if (mode === "login") {
        await login(email, password);
        toast.success("Bentornato!");
      } else {
        await register(name, email, password);
        toast.success("Account creato!");
      }
      nav("/diagnosi");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 pt-16">
      <div className="w-full max-w-md rise">
        <div className="flex items-center gap-2.5 justify-center mb-8">
          <span className="w-11 h-11 rounded-xl bg-[#F97316] flex items-center justify-center shadow-[0_0_24px_rgba(249,115,22,0.45)]">
            <Wrench className="w-6 h-6 text-black" strokeWidth={2.5} />
          </span>
          <span className="font-display font-black text-2xl tracking-wide">
            MOTORA<span className="text-[#F97316]">.AI</span>
          </span>
        </div>

        <div className="rounded-2xl bg-[#111823] border border-white/10 p-7">
          <div className="flex rounded-lg bg-[#0B0F14] p-1 mb-6">
            {["login", "register"].map((m) => (
              <button
                key={m}
                data-testid={`auth-tab-${m}`}
                onClick={() => { setMode(m); setErr(""); }}
                className={`flex-1 py-2 rounded-md text-sm font-semibold transition-colors ${
                  mode === m ? "bg-[#F97316] text-black" : "text-zinc-400 hover:text-white"
                }`}
              >
                {m === "login" ? "Accedi" : "Registrati"}
              </button>
            ))}
          </div>

          <form onSubmit={submit} className="space-y-4">
            {mode === "register" && (
              <div>
                <label className="block text-xs uppercase tracking-wider text-zinc-400 mb-1.5">Nome</label>
                <input
                  data-testid="auth-name-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="w-full rounded-lg bg-[#0B0F14] border border-white/10 px-3 py-2.5 text-sm focus:border-[#F97316] focus:outline-none transition-colors"
                  placeholder="Mario Rossi"
                />
              </div>
            )}
            <div>
              <label className="block text-xs uppercase tracking-wider text-zinc-400 mb-1.5">Email</label>
              <input
                data-testid="auth-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full rounded-lg bg-[#0B0F14] border border-white/10 px-3 py-2.5 text-sm focus:border-[#F97316] focus:outline-none transition-colors"
                placeholder="tu@email.it"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-wider text-zinc-400 mb-1.5">Password</label>
              <input
                data-testid="auth-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                className="w-full rounded-lg bg-[#0B0F14] border border-white/10 px-3 py-2.5 text-sm focus:border-[#F97316] focus:outline-none transition-colors"
                placeholder="••••••••"
              />
            </div>

            {err && <p data-testid="auth-error" className="text-sm text-red-400">{err}</p>}

            <button
              data-testid="auth-login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg bg-[#F97316] hover:bg-[#EA580C] text-black font-bold transition-colors disabled:opacity-60 shadow-[0_0_20px_rgba(249,115,22,0.35)]"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              {mode === "login" ? "Accedi" : "Crea account"}
            </button>
          </form>
        </div>
        <p className="text-center text-xs text-zinc-500 mt-4 font-mono">Demo: admin@motora.ai / admin123</p>
      </div>
    </div>
  );
}
